import { useMemo } from 'react';
import { Media } from '../interfaces/campaign';
import { useTranslation } from 'react-i18next';

interface CustomColors {
	bgClass: string;
	pageCardBgClass: string;
	pageCardBorderColor: string;
	viewButtonBorderColor: string;
	viewButtonTextColor: string;
	dividerColor: string;
	label: string;
}

function usePageCardColors(selectedPlatform: Media): CustomColors {
	const { t } = useTranslation();

	const customColors = useMemo(() => {
		let bgClass = '';
		let pageCardBgClass = '';
		let pageCardBorderColor = '';
		let viewButtonBorderColor = '';
		let viewButtonTextColor = '';
		let dividerColor = '';
		let label = '';

		switch (selectedPlatform) {
			case 'telegram':
				bgClass = 'bg-primary-main';
				pageCardBgClass = 'bg-primary-selected';
				pageCardBorderColor = 'to-primary-main';
				dividerColor = 'border-primary-selected';
				viewButtonBorderColor = 'border-primary-focuse';
				viewButtonTextColor = 'text-primary-main';
				label = t('group_and_channel');
				break;
			case 'instagram':
				bgClass = 'bg-secondary-main';
				pageCardBgClass = 'bg-secondary-selected';
				pageCardBorderColor = 'to-secondary-main';
				dividerColor = 'border-secondary-selected';
				viewButtonBorderColor = 'border-secondary-main';
				viewButtonTextColor = 'text-secondary-main';
				label = t('page');
				break;
			case 'rubika':
				bgClass = 'bg-green-main';
				pageCardBgClass = 'bg-green-selected';
				pageCardBorderColor = 'to-green-main';
				dividerColor = 'border-green-selected';
				viewButtonBorderColor = 'border-green-main';
				viewButtonTextColor = 'text-green-main';
				label = t('group_and_channel');
				break;
			case 'eita':
				bgClass = 'bg-orange-main';
				pageCardBgClass = 'bg-orange-selected';
				pageCardBorderColor = 'to-orange-main';
				dividerColor = 'border-orange-selected';
				viewButtonBorderColor = 'border-orange-main';
				viewButtonTextColor = 'text-orange-main';
				label = t('group_and_channel');
				break;
			case 'soroush':
				bgClass = 'bg-primary-main';
				pageCardBgClass = 'bg-primary-selected';
				pageCardBorderColor = 'to-primary-main';
				dividerColor = 'border-primary-selected';
				viewButtonBorderColor = 'border-primary-main';
				viewButtonTextColor = 'text-primary-main';
				label = t('group_and_channel');
				break;
			case 'bale':
				bgClass = 'bg-green-main';
				pageCardBgClass = 'bg-green-selected';
				pageCardBorderColor = 'to-green-main';
				dividerColor = 'border-green-selected';
				viewButtonBorderColor = 'border-green-main';
				viewButtonTextColor = 'text-green-main';
				label = t('group_and_channel');
				break;
			case 'influenceral':
				bgClass = 'bg-primary-main';
				pageCardBgClass = 'bg-primary-selected';
				pageCardBorderColor = 'to-primary-main';
				dividerColor = 'border-primary-selected';
				viewButtonBorderColor = 'border-primary-focuse';
				viewButtonTextColor = 'text-primary-main';
				label = t('group_and_channel');
				break;
			case 'app':
				bgClass = 'bg-green-main';
				pageCardBgClass = 'bg-green-selected';
				pageCardBorderColor = 'to-green-main';
				dividerColor = 'border-green-selected';
				viewButtonBorderColor = 'border-green-main';
				viewButtonTextColor = 'text-green-main';
				label = t('app');
				break;
			case 'sms':
				bgClass = 'bg-primary-main';
				pageCardBgClass = 'bg-primary-selected';
				pageCardBorderColor = 'to-primary-main';
				dividerColor = 'border-primary-selected';
				viewButtonBorderColor = 'border-primary-main';
				viewButtonTextColor = 'text-primary-main';
				label = t('panel');
				break;
			case 'media_growth':
				bgClass = 'bg-orange-main';
				pageCardBgClass = 'bg-orange-selected';
				pageCardBorderColor = 'to-orange-main';
				dividerColor = 'border-orange-selected';
				viewButtonBorderColor = 'border-orange-main';
				viewButtonTextColor = 'text-orange-main';
				label = t('channel_and_page');
				break;
			case 'website_ad':
				bgClass = 'bg-secondary-main';
				pageCardBgClass = 'bg-secondary-selected';
				pageCardBorderColor = 'to-secondary-main';
				dividerColor = 'border-secondary-selected';
				viewButtonBorderColor = 'border-secondary-main';
				viewButtonTextColor = 'text-secondary-main';
				label = t('website');
				break;
			default:
				bgClass = '';
				pageCardBgClass = '';
				pageCardBorderColor = '';
				label = '';
				dividerColor = '';
				viewButtonBorderColor = '';
				viewButtonTextColor = '';
		}

		return {
			bgClass,
			pageCardBgClass,
			pageCardBorderColor,
			viewButtonBorderColor,
			viewButtonTextColor,
			dividerColor,
			label,
		};
	}, [selectedPlatform]);

	return customColors;
}

export default usePageCardColors;
